import * as React from 'react';
import styled from "styled-components";
import StatisticLocation from "../components/StatisticLocation";
import {TwoColumnTableProps} from "components/TwoColumnTable";
import StatisticActivity from "../components/StatisticActivity";
import StatisticSessionTime from "../components/StatisticSessionTime";
import StatisticGenders from "../components/StatisticGenders";

const Container = styled.div`
  display: grid;
  gap: 10px;
  margin-bottom: 120px;
`;

const Box = styled.div`
  padding: 20px;
  border-radius: 5px;
  border:
    1px
    solid
    ${({theme}) => theme.variables.borderColor};
  background-color: ${({theme}) => theme.variables.accentBackgroundColor};
`;

const BoxTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;
  margin-bottom: 20px;
  color: ${({theme}) => theme.variables.color}
`;

export default function TabStatistics() {
  const colors = [
    '#6EB6FF',
    '#DC57D2',
    '#FF9979',
    '#93FFD1',
    '#FFF175',
  ]

  const countryData:TwoColumnTableProps = {
    firstHeaderLabel: 'Страна',
    secondHeaderLabel: 'Количество',
    items: [
      {
        color: colors[0],
        label: 'Россия',
        value: '70%',
      },
      {
        color: colors[1],
        label: 'Украина',
        value: '15%',
      },
      {
        color: colors[2],
        label: 'США',
        value: '7.5%',
      },
      {
        color: colors[3],
        label: 'Великобритания',
        value: '7.5%',
      },
    ]
  }

  const cityData:TwoColumnTableProps = {
    firstHeaderLabel: 'Город',
    secondHeaderLabel: 'Количество',
    items: [
      {
        color: colors[0],
        label: 'Москва',
        value: '70%',
      },
      {
        color: colors[1],
        label: 'Владимир',
        value: '20%',
      },
      {
        color: colors[2],
        label: 'Екатеринбург',
        value: '10%',
      },
      {
        color: colors[3],
        label: 'Тюмень',
        value: '10%',
      },
      {
        color: colors[4],
        label: 'другие',
        value: '10%',
      },
    ]
  }

  const activityData:TwoColumnTableProps = {
    firstHeaderLabel: 'Курс',
    secondHeaderLabel: 'Количество активных студентов',
    items: [
      {
        color: colors[0],
        label: 'Особенности современного маркетинга',
        value: 1085483,
      },
      {
        color: colors[1],
        label: 'Бизнес-стратегия',
        value: 234456,
      },
      {
        color: colors[2],
        label: 'Маркетинг и управление',
        value: 105385,
      },
    ]
  }

  const sessionData:TwoColumnTableProps = {
    firstHeaderLabel: 'Курс',
    secondHeaderLabel: 'среднее время за сессию',
    items: [
      {
        color: colors[0],
        label: 'Особенности современного маркетинга',
        value: '12.56',
      },
      {
        color: colors[1],
        label: 'Бизнес-стратегия',
        value: '3.5',
      },
      {
        color: colors[2],
        label: 'Маркетинг и управление',
        value: '6.30',
      },
    ]
  }

  return (
    <Container>
      <Box>
        <BoxTitle>Пол / Возраст</BoxTitle>
        <StatisticGenders
          data={{
            men: [2, 7, 20, 30, 22, 8, 7, 1],
            woman:[5, 10, 25, 25, 24, 10, 8, 2],
          }}
        />
      </Box>
      <Box>
        <BoxTitle>Страна / Город</BoxTitle>
        <StatisticLocation
          countryData={countryData}
          cityData={cityData}
          colors={colors}
        />
      </Box>
      <Box>
        <BoxTitle>Активность</BoxTitle>
        <StatisticActivity
          data={activityData}
          colors={colors}
        />
      </Box>
      <Box>
        <BoxTitle>Среднее время за сессию</BoxTitle>
        <StatisticSessionTime
          data={sessionData}
          colors={colors}
        />
      </Box>
    </Container>
  )
}